import React from 'react'

const ReAssignComplaint = () => {
  return (
    <div>ReAssignComplaint</div>
  )
}

export default ReAssignComplaint